/**
 * La web pública en dos idiomas: castellano sin prefijo y el inglés bajo /en.
 *
 * Las rutas en inglés cuelgan de `app/[lang]`, el mismo segmento que usa el
 * directorio en otros idiomas (/en/restaurants, /en/digital-menu): Next no
 * admite dos segmentos dinámicos hermanos, así que allí se reparte por slug.
 */
export type Idioma = "es" | "en"

export const RUTA = {
  portada: { es: "/", en: "/en" },
  modulos: { es: "/modulos", en: "/en/modules" },
  precios: { es: "/precios", en: "/en/pricing" },
  work: { es: "/work", en: "/en/work" },
  integraciones: { es: "/integraciones", en: "/en/integrations" },
  sectores: { es: "/para", en: "/en/for" },
  cartaDigital: { es: "/carta-digital", en: "/en/digital-menu" },
  guia: { es: "/restaurantes", en: "/en/restaurants" },
} as const

export function ruta(idioma: Idioma, donde: keyof typeof RUTA, ...resto: string[]): string {
  const base = RUTA[donde][idioma]
  return resto.length ? `${base === "/" ? "" : base}/${resto.join("/")}` : base
}

/** 1900 → «19,00 €» en castellano, «€19.00» en inglés. */
export function eurosEn(idioma: Idioma, centimos: number, redondo = false): string {
  const valor = centimos / 100
  const sinDecimales = redondo && centimos % 100 === 0
  if (idioma === "en") return `€${sinDecimales ? valor.toFixed(0) : valor.toFixed(2)}`
  return `${sinDecimales ? valor.toFixed(0) : valor.toFixed(2).replace(".", ",")} €`
}
